/** 库存管理（990390+；990380=售后服务总目录，勿占用） */
export const STORE_MATERIAL_MENU_IDS = {
  group: 990390,
  stock: 990391,
  orders: 990392,
  consumable: 990393,
  mq: 990394,
  invoice: 990395,
  barcodeAlias: 990396,
  count: 990397,
  bomWizard: 990398,
  analytics: 990399,
  physicalMerge: 990400
}



// WEBPACK FOOTER //
// ./src/constants/storeMaterial.js